import { Component, Input, SimpleChanges } from '@angular/core';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SharedModule } from '../../shared.module';
import { TranslateService } from '@ngx-translate/core';

import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-overlay',
  templateUrl: './overlay.component.html',
  styleUrls: ['./overlay.component.scss'],
  imports: [MatProgressBarModule, SharedModule, MatIconModule],
})
export class OverlayComponent {
  @Input() message?: string;
  @Input() subTitle?: string;
  @Input() loaderBar?: boolean;
  @Input() exitUrl?: string;
  @Input() success?: boolean;

  overlayMessage: string = 'OVERLAY_COMPONENT.STANDARD_MESSAGE';
  overlaySubTitle: string = '';

  constructor(private translateService: TranslateService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['message']) {
      this.overlayMessage =
        this.message || 'OVERLAY_COMPONENT.STANDARD_MESSAGE';
    }
    if (changes['subTitle']) {
      this.overlaySubTitle = this.subTitle || '';
    }
  }

  getTranslation(value: string) {
    return value ? this.translateService.instant(value) : '';
  }
}
